import { Component, Input, OnInit } from '@angular/core';

import { checkmarkIcon, closeLightIcon } from '../../../icons';
import { FieldBaseComponent } from '../field-base/field-base.model';
import { UntypedFormControl } from '@angular/forms';

@Component({
    selector: 'app-input',
    template: `
        <div class="input" [formGroup]="parentForm">
            <label>
                <div class="input__wrapper" [class.license-plate]="asLicensePlate">
                    <input
                        [type]="type"
                        class="input__input-element"
                        [formControlName]="controlName"
                        [ngClass]="cssClasses"
                        [class.input__input-element--not-empty]="inputControl?.value || type === 'time'"
                        [email]="type === 'email'"
                        [appAutoFocus]="autoFocus"
                        [autocomplete]="autocomplete"
                        [attr.inputmode]="inputMode"
                    />
                    <span class="input__label">{{ label }}</span>
                    <span class="input__validation-icon">
                        <i aria-hidden="true" class="input__icon" *ngIf="inputControl?.errors; else validTmpl">${closeLightIcon}</i>
                        <ng-template #validTmpl>
                            <i aria-hidden="true" *ngIf="inputControl?.value !== undefined" class="input__icon">${checkmarkIcon}</i>
                        </ng-template>
                    </span>

                    <!-- You guessed it -->
                    <div *ngIf="asLicensePlate" class="license-plate-details">
                        <div class="license-plate-details__stars"></div>
                        <div class="license-plate-details__country-code text-small bold">DK</div>
                    </div>
                </div>

                <p class="help is-danger" *ngIf="inputControl?.errors && inputControl?.touched">
                    <ng-container *ngIf="inputControl?.errors?.required">
                        {{ 'forms.validation_message____field_required' | translate }}
                    </ng-container>
                    <ng-container *ngIf="inputControl?.errors?.email">
                        {{ 'forms.validation_message____email' | translate }}
                    </ng-container>
                    <ng-container *ngIf="inputControl?.errors?.minlength">
                        {{ 'forms.validation_message____minlength' | translate: { value: inputControl?.errors?.minlength?.requiredLength } }}
                    </ng-container>
                    <ng-container *ngIf="inputControl?.errors?.maxlength">
                        {{ 'forms.validation_message____maxlength' | translate: { value: inputControl?.errors?.maxlength?.requiredLength } }}
                    </ng-container>
                    <ng-container *ngIf="inputControl?.errors?.pattern?.requiredPattern === '^[0-9]*$'">
                        {{ 'forms.validation_message____only_whole_numbers' | translate }}
                    </ng-container>
                </p>
            </label>
        </div>
    `,
})
export class InputComponent extends FieldBaseComponent implements OnInit {
    @Input() cssClasses: string;
    @Input() label: string;
    @Input() type = 'text';
    @Input() asLicensePlate = false;
    @Input() autoFocus?: boolean;
    @Input() autocomplete?: string;
    @Input() inputMode: 'decimal' | 'email' | 'tel' | undefined;

    constructor() {
        super();
    }

    ngOnInit(): void {
        // If input is for license plate, we want to display the value in uppercase
        if (this.asLicensePlate && this.inputControl instanceof UntypedFormControl) {
            this.inputControl.valueChanges.subscribe((value: string) => {
                if (value !== value.toUpperCase()) {
                    this.inputControl?.setValue(value.toUpperCase(), { emitEvent: false });
                }
            });
        }
    }
}
